import React from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { Chip } from "@mui/material";

const PortfolioGridHSTable = () => {
  const columns = [
    { field: "id", headerName: "ID", width: 20, hide: true },
    {
      field: "buildingName",
      headerName: "Building Name",
      width: 250,
      editable: false,
    },
    {
      field: "location",
      headerName: "Location",
      width: 180,
      editable: false,
    },
    {
      field: "buildingType",
      headerName: "Building Type",
      width: 140,
      editable: false,
    },
    {
      field: "managedSpace",
      headerName: "Managed Square Footage",
      width: 120,
      editable: false,
    },
    {
      field: "aqi",
      headerName: "Air Quality Index (AQI)",
      width: 120,
      editable: false,
    },
    {
      field: "tempHumid",
      headerName: "Temperature and Humidity",
      width: 120,
      editable: false,
    },
    {
      field: "emergencyResponse",
      headerName: "Emergency Response Readiness (Fire Alarms, Exits)",
      width: 230,
      editable: false,
    },
    {
      field: "maintenanceSchedule",
      headerName: "Maintenance Schedule Compliance",
      width: 200,
      editable: false,
    },
    {
      field: "wellCert",
      headerName: "Well Certification Level (Silver, Gold, Platinum)",
      width: 200,
      editable: false,
    },
  ];

  const rows = [
    {
      id: 1,
      buildingName: "Contoso Tower - Toronto",
      location: "Downtown Toronto, ON",
      buildingType: "Office",
      managedSpace: 150000,
      aqi: 45,
      tempHumid: "22°C, 60%",
      emergencyResponse: "Compliant",
      maintenanceSchedule: "Quarterly",
      wellCert: "Gold",
    },
    {
      id: 2,
      buildingName: "Contoso Plaza - Ottawa",
      builtYear: 2015,
      location: "ByWard Market, Ottawa, ON",
      buildingType: "Mixed-Use",
      managedSpace: 120000,
      aqi: 50,
      tempHumid: "21°C, 55%",
      emergencyResponse: "Compliant",
      maintenanceSchedule: "Monthly",
      wellCert: "Platinum",
    },
    {
      id: 3,
      buildingName: "Contoso Residences - Vancouver",
      builtYear: 2018,
      location: "Coal Harbour, Vancouver, BC",
      buildingType: "Residential",
      managedSpace: 90000,
      aqi: 35,
      tempHumid: "20°C, 50%",
      emergencyResponse: "Non-Compliant",
      maintenanceSchedule: "Monthly",
      wellCert: "Silver",
    },
    {
      id: 4,
      buildingName: "Contoso Innovation Hub - Calgary",
      builtYear: 2021,
      location: "Downtown Calgary, AB",
      buildingType: "Office",
      managedSpace: 200000,
      aqi: 55,
      tempHumid: "23°C, 58%",
      emergencyResponse: "Compliant",
      maintenanceSchedule: "Semi-Annual",
      wellCert: "Gold",
    },
    {
      id: 5,
      buildingName: "Contoso Heights - Montreal",
      builtYear: 2016,
      location: "Plateau Mont-Royal, Montreal, QC",
      buildingType: "Residential",
      managedSpace: 110000,
      aqi: 42,
      tempHumid: "22°C, 65%",
      emergencyResponse: "Compliant",
      maintenanceSchedule: "Annual",
      wellCert: "Silver",
    },
    {
      id: 6,
      buildingName: "Contoso Wellness Center - Halifax",
      builtYear: 2012,
      location: "Downtown Halifax, NS",
      buildingType: "Healthcare",
      managedSpace: 95000,
      aqi: 48,
      tempHumid: "19°C, 60%",
      emergencyResponse: "Non-Compliant",
      maintenanceSchedule: "Monthly",
      wellCert: "Gold",
    },
    {
      id: 7,
      buildingName: "Contoso Retail Space - Edmonton",
      builtYear: 2019,
      location: "West Edmonton Mall, AB",
      buildingType: "Commercial",
      managedSpace: 130000,
      aqi: 53,
      tempHumid: "24°C, 62%",
      emergencyResponse: "Compliant",
      maintenanceSchedule: "Quarterly",
      wellCert: "Platinum",
    },
    {
      id: 8,
      buildingName: "Contoso Eco Park - Saskatoon",
      builtYear: 2020,
      location: "Meewasin Valley, Saskatoon, SK",
      buildingType: "Mixed-Use",
      managedSpace: 70000,
      aqi: 40,
      tempHumid: "18°C, 55%",
      emergencyResponse: "Compliant",
      maintenanceSchedule: "Semi-Annual",
      wellCert: "Silver",
    },
    {
      id: 9,
      buildingName: "Contoso Tower - Victoria",
      builtYear: 2014,
      location: "Downtown Victoria, BC",
      buildingType: "Office",
      managedSpace: 160000,
      aqi: 49,
      tempHumid: "21°C, 58%",
      emergencyResponse: "Compliant",
      maintenanceSchedule: "Annual",
      wellCert: "Gold",
    },
    {
      id: 10,
      buildingName: "Contoso Conference Center - Winnipeg",
      builtYear: 2018,
      location: "The Forks, Winnipeg, MB",
      buildingType: "Event Space",
      managedSpace: 85000,
      aqi: 60,
      tempHumid: "23°C, 63%",
      emergencyResponse: "Non-Compliant",
      maintenanceSchedule: "Monthly",
      wellCert: "Platinum",
    },
  ];

  return (
    <>
      <Box sx={{ height: "350px", width: "100%", overflow: "auto" }}>
        <DataGrid
          sx={{
            color: "white",
            "& .MuiDataGrid-menuIconButton": {
              color: "white",
            },
            "& .MuiCheckbox-root": {
              color: "white",
            },

            "& .MuiDataGrid-sortIcon": {
              color: "white",
            },

            "& .MuiTablePagination-root": {
              bgcolor: "white",
            },
            "& .MuiDataGrid-cell": {
              border: 0,
            },
            "& .MuiDataGrid-row:hover": {
              bgcolor: "primary.main",
            },
            "& .MuiDataGrid-cell:hover": {
              bgcolor: "none",
            },
            "& .MuiDataGrid-cell:focus": {
              bgcolor: "primary.light",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
              lineHeight: "1.5",
              whiteSpace: "normal",
            },

            "& .MuiDataGrid-cell": {
              textAlign: "center", // Centering cell content
            },
          }}
          rows={rows}
          columns={columns}
          initialState={{}}
          checkboxSelection
          disableRowSelectionOnClick
        />
      </Box>
    </>
  );
};

export default PortfolioGridHSTable;
